// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-TravelersList-styles___pageHeaderWrapper--pV8ou {
  display: flex;
  justify-content: space-between;
}

.components-TravelersList-styles___clickable--X5Mqs {
  cursor: pointer;
}

.components-TravelersList-styles___tableHead--Of7DA {
  color: #1b2432 !important;
  font-weight: 500 !important;
  font-size: 15px !important;
}

.components-TravelersList-styles___tableRow--wgKiZ:last-child .components-TravelersList-styles___tableRowCell--WwEdy {
      border: none;
    }

.components-TravelersList-styles___tableRow--wgKiZ:hover {
    background: #f6f6f7;
  }

.components-TravelersList-styles___paper--BU6P0 {
  position: relative;
}

.components-TravelersList-styles___tableRowCell--WwEdy {
  padding: 4px 24px 4px 24px !important;
  font-size: 15px !important;
  max-width: 180px !important;
  min-width: 140px !important;
  text-overflow: ellipsis;
  overflow: hidden;
}

.components-TravelersList-styles___tableRowCellEmail--gVlzX {
  max-width: 300px !important;
}

.components-TravelersList-styles___tableRowCellBirthDate--N__nf {
  max-width: 70px !important;
}

.components-TravelersList-styles___clickable--X5Mqs {
  cursor: pointer;
}

.components-TravelersList-styles___searchField--PNUM0 {
  background-color: #fff;
  min-width: 300px !important;
}

.components-TravelersList-styles___userName--qJoGX {
  margin-bottom: 8px !important;
}

.components-TravelersList-styles___companyName--EYzeg {
  text-align: left;
  font-size: 17px;
  color: #1b2432;
  letter-spacing: 0;
  margin-bottom: 32px;
}
`, "",{"version":3,"sources":["webpack://./components/TravelersList/styles.pcss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAII;MACE,YAAY;IACd;;AAGF;IACE,mBAAmB;EACrB;;AAGF;EACE,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB","sourcesContent":[".pageHeaderWrapper {\n  display: flex;\n  justify-content: space-between;\n}\n\n.clickable {\n  cursor: pointer;\n}\n\n.tableHead {\n  color: #1b2432 !important;\n  font-weight: 500 !important;\n  font-size: 15px !important;\n}\n\n.tableRow {\n  &:last-child {\n    .tableRowCell {\n      border: none;\n    }\n  }\n\n  &:hover {\n    background: #f6f6f7;\n  }\n}\n\n.paper {\n  position: relative;\n}\n\n.tableRowCell {\n  padding: 4px 24px 4px 24px !important;\n  font-size: 15px !important;\n  max-width: 180px !important;\n  min-width: 140px !important;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n.tableRowCellEmail {\n  max-width: 300px !important;\n}\n\n.tableRowCellBirthDate {\n  max-width: 70px !important;\n}\n\n.clickable {\n  cursor: pointer;\n}\n\n.searchField {\n  background-color: #fff;\n  min-width: 300px !important;\n}\n\n.userName {\n  margin-bottom: 8px !important;\n}\n\n.companyName {\n  text-align: left;\n  font-size: 17px;\n  color: #1b2432;\n  letter-spacing: 0;\n  margin-bottom: 32px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageHeaderWrapper": `components-TravelersList-styles___pageHeaderWrapper--pV8ou`,
	"clickable": `components-TravelersList-styles___clickable--X5Mqs`,
	"tableHead": `components-TravelersList-styles___tableHead--Of7DA`,
	"tableRow": `components-TravelersList-styles___tableRow--wgKiZ`,
	"tableRowCell": `components-TravelersList-styles___tableRowCell--WwEdy`,
	"paper": `components-TravelersList-styles___paper--BU6P0`,
	"tableRowCellEmail": `components-TravelersList-styles___tableRowCellEmail--gVlzX`,
	"tableRowCellBirthDate": `components-TravelersList-styles___tableRowCellBirthDate--N__nf`,
	"searchField": `components-TravelersList-styles___searchField--PNUM0`,
	"userName": `components-TravelersList-styles___userName--qJoGX`,
	"companyName": `components-TravelersList-styles___companyName--EYzeg`
};
module.exports = ___CSS_LOADER_EXPORT___;
